/**
 * Sections for the GROUPED school-shop layout, straight from the variations
 * payload's `collections[]` (already ordered by the BE: group order, then
 * collection order, ungrouped last; a group page carries only its own
 * collections). One section per collection with at least one card:
 *   { id, caption: subtitle | undefined, captionVariant: 'default',
 *     title: displayName, oddCard: 'first' | 'last' | undefined,
 *     items: [ProductsGrid card, …] }
 * `cardsById` maps a variation id to its ProductsGrid card (built by the page
 * from the live variations, so clicks open the real configurator).
 * `oddCard` is the listing setting «where the large card goes when the count is
 * odd» (phones only — DS ProductsGrid `oddCard`): the collection's own
 * `oddCard`, else `defaults.oddCard` (the group's / the page's), else undefined
 * (the DS default, the last card). Any other value is dropped.
 */
export const ODD_CARD_VALUES = ['first', 'last'];
export const readOddCard = (value) => (ODD_CARD_VALUES.includes(value) ? value : undefined);

export default function buildGroupedSections(collections, cardsById, defaults = {}) {
  const list = Array.isArray(collections) ? collections : [];
  const fallback = readOddCard(defaults.oddCard);
  return list
    .map((c) => ({
      id: `collection-${c.id}`,
      caption: c.subtitle || undefined,
      captionVariant: 'default',
      title: c.displayName || c.name || '',
      oddCard: readOddCard(c.oddCard) ?? fallback,
      items: (Array.isArray(c.variationIds) ? c.variationIds : [])
        .map((id) => cardsById?.[id] ?? cardsById?.[String(id)])
        .filter(Boolean),
    }))
    .filter((s) => s.items.length > 0);
}
